import {Injectable, signal} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {

  private _sidebarOpen = signal(true);
  sidebarOpen = this._sidebarOpen.asReadonly();
  topbarVisible = signal(true);

  toggleSidebar() {
    this._sidebarOpen.update(v => !v);
  }

  openSidebar() {
    this._sidebarOpen.set(true);
  }

  closeSidebar() {
    this._sidebarOpen.set(false);
  }
}
